// extracted by mini-css-extract-plugin
module.exports = {"downloadCSVButton":"styles_downloadCSVButton__2BNnz","tableWrapper":"styles_tableWrapper__1HeMB","actions":"styles_actions__18QQj"};